<template>
  <div class="flex items-center gap-2">
    <v-avatar color="primary" size="32">
      <span class="text-md font-bold">{{ initials }}</span>
    </v-avatar>
    <span class="truncate overflow-hidden text-left">{{ name }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  name: string
}>()

const initials = computed(() => {
  if (!props.name) return ''
  return props.name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .substring(0, 2)
    .toUpperCase()
})
</script>
